import React, { Fragment, useState } from 'react';
import { Tree } from 'primereact/tree';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { FcFolder } from "react-icons/fc";
import { ProgressSpinner } from 'primereact/progressspinner';
import IconInputText from '../../component/iconInputText/iconInputText';

// Sample file system data
const fileSystem = [
  {
    key: '0',
    label: 'Documents',
    children: [
      { key: '0-0', label: 'file1.txt', icon: 'pi pi-file' },
      { key: '0-1', label: 'file2.txt', icon: 'pi pi-file' },
    ]
  },
  {
    key: '1',
    label: 'Images',
    children: [
      { key: '1-0', label: 'image1.png', icon: 'pi pi-file-image' },
      { key: '1-1', label: 'image2.jpg', icon: 'pi pi-file-image' },
    ]
  },
];

const FileExplorerDirectory = ({ onFolderClick, closeDialog, loading, directoryLabelKey, directory }) => {
  const [searchVal, setSearchVal] = useState("")


  return (
    <div>
      {/* <h2>File Explorer</h2> */}

      {/* PrimeReact Tree Component */}
      {/* <Tree
        value={fileSystem}
        onSelect={onNodeSelect}
        showCheckbox={false}
      /> */}

      {/* Dialog for Viewing File */}
      <Dialog
        visible={true}
        style={{ width: '80%' }}
        header={<Fragment><div className='grid'>
          <div className='col-6'>
            File Explorer
          </div>
          <div className='col-6'>
            <IconInputText iconPosition="left" style={{ width: "100%", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search Directory" />
          </div>
        </div></Fragment>}
        modal
        onHide={closeDialog}
      >
        {loading ? <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div> :
          <div className='grid'>
            {searchVal === "" ?
              directory.map((val) => {
                return <div className='col-3'><Fragment>
                  <FcFolder size={40} className='handCursor' onClick={() => {
                    onFolderClick(val)
                    closeDialog()
                  }
                  } />
                  <div style={{ overflowWrap: "anywhere" }}>{val[directoryLabelKey]}</div>
                </Fragment>
                </div>
              })
              :
              directory.filter((val1) => val1[directoryLabelKey].toLowerCase().includes(searchVal.toLowerCase())).map((val) => {
                return <div className='col-3'><Fragment>
                  <FcFolder size={40} className='handCursor' onClick={() => {
                    onFolderClick(val)
                    closeDialog()
                  }
                  } />
                  <div style={{ overflowWrap: "anywhere" }}>{val[directoryLabelKey]}</div>
                </Fragment>
                </div>
              })
            }
          </div>
        }
      </Dialog>
    </div>
  );
};

export default FileExplorerDirectory;
